import { ROUTES } from '@/core/constants/routes'
import { Link } from '@/i18n/navigation'
import { cn } from '@heroui/react'
import React from 'react'

export const NotificationMessage: React.FC<{
  title: string
  body?: string
  payload?: Record<string, unknown>
}> = ({ title, body, payload }) => {
  const isClickable = Boolean(
    payload?.chat_id || (payload?.id && payload?.type === 'trip'),
  )

  const getHref = () => {
    if (!isClickable) return ''
    if (payload?.chat_id) {
      return ROUTES.chat(payload.chat_id as string)
    }
    if (payload?.id && payload?.type === 'trip') {
      return ROUTES.chat(payload.id as string)
    }

    return ''
  }

  return (
    <Link
      href={getHref()}
      className={cn(isClickable ? 'cursor-pointer' : 'pointer-events-none')}
    >
      <h6 className='text-lg font-medium'>{title}</h6>
      {body ? <p>{body}</p> : null}
      {payload?.trip_id ? (
        <p className='text-sm text-gray-500'>
          at trip #{payload.trip_id as string}
        </p>
      ) : null}
    </Link>
  )
}
